// extracted by mini-css-extract-plugin
export default {"agenda":"Agenda_agenda__IChNl","title":"Agenda_title__L5EUc","searchBar":"Agenda_searchBar__nVQVL"};